export default __webpack_public_path__ + "4a783aa0368051519711e16342184394.webp";